import { DateTime } from "luxon";

function calculateHours(startDateStr: string, endDateStr: string): number {
  if (!startDateStr || !endDateStr) return 0;
  const start = DateTime.fromISO(startDateStr, { zone: "utc" });
  const end = DateTime.fromISO(endDateStr, { zone: "utc" });
  if (!start.isValid || !end.isValid) return 0;
  return Math.max(0, (end.toMillis() - start.toMillis()) / (1000 * 60 * 60));
}

export { calculateHours };
